import { usePersistedSessionState } from "@edreamsodigeo/frontend-core";

const useHasFlightDiscountSelectedBySessionStorage = ():
  | boolean
  | undefined => {
  const [selectionData] = usePersistedSessionState("flightSelectionData");
  const [subscriptionSelectedOnContinue] = usePersistedSessionState(
    "subscriptionSelectedOnContinue",
  );

  return (
    !selectionData?.data?.priceWithoutDiscountSelected ||
    subscriptionSelectedOnContinue === "prime"
  );
};

export default useHasFlightDiscountSelectedBySessionStorage;
